(() => {
  const init = (root) => {
    const section = root.matches?.('[data-stride-landing-services]')
      ? root
      : root.querySelector?.('[data-stride-landing-services]');

    if (!section || section.dataset.servicesReady === 'true') return;
    section.dataset.servicesReady = 'true';

    const items = [...section.querySelectorAll('[data-service-item]')];
    const media = [...section.querySelectorAll('[data-service-media]')];

    const activate = (index) => {
      media.forEach((item) => {
        item.classList.toggle('is-active', Number(item.dataset.serviceMedia) === index);
      });
    };

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((other) => {
          if (other !== item) other.open = false;
        });

        activate(Number(item.dataset.serviceIndex));
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-stride-landing-services]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();